import { Card, ListGroup } from 'react-bootstrap';
import { type IProductOffer } from '../../types/IProduct';
import { useMemo } from 'react';
import { formatCurrency } from '../../utils/formatCurrency';
import { getImageWithFallback } from '../../utils/getImage';

interface OfferCardProps {
  offer: IProductOffer;
}

export const OfferCard: React.FC<OfferCardProps> = ({ offer }) => {
  const offerImageLink = useMemo(() => {
    return getImageWithFallback(offer.image, offer.catalog?.image);
  }, [offer.image, offer.catalog?.image]);

  return (
    <Card
      style={{
        width: '18rem',
        minHeight: 'fit-content',
        minWidth: '300px',
        userSelect: 'none',
        pointerEvents: 'none'
      }}
      className="shadow-sm p-3 rounded"
      bg={offer.available ? 'unknown' : 'warning'}
    >
      <Card.Img variant="top" src={offerImageLink} draggable="false" />
      <Card.Body>
        <Card.Title>{offer.name}</Card.Title>
      </Card.Body>
      <ListGroup className="list-group-flush">
        <ListGroup.Item variant={offer.available ? 'unknown' : 'warning'}>
          <span>
            <strong>Цена без скидки:</strong>
          </span>{' '}
          <span className="text-muted">{formatCurrency(offer.price)}</span>
        </ListGroup.Item>
        <ListGroup.Item variant={offer.available ? 'unknown' : 'warning'}>
          <span>
            <strong>Цена по акции:</strong>
          </span>{' '}
          {offer.akcia !== null ? (
            <span className="text-muted">{formatCurrency(offer.akcia)}</span>
          ) : (
            <span className="text-danger">--</span>
          )}
        </ListGroup.Item>
        <ListGroup.Item variant={offer.available ? 'unknown' : 'warning'}>
          <span>
            <strong>Цена по распродаже:</strong>
          </span>{' '}
          {offer.price_sale !== null ? (
            <span className="text-muted">
              {formatCurrency(offer.price_sale)}
            </span>
          ) : (
            <span className="text-danger">--</span>
          )}
        </ListGroup.Item>
        <ListGroup.Item variant={offer.available ? 'unknown' : 'warning'}>
          <span>
            <strong>Процент скидки:</strong>
          </span>{' '}
          {offer.percent !== null ? (
            <span className="text-muted">{offer.percent}%</span>
          ) : (
            <span className="text-danger">--</span>
          )}
        </ListGroup.Item>
        <ListGroup.Item variant={offer.available ? 'unknown' : 'warning'}>
          <span>
            <strong>Цена закупки:</strong>
          </span>{' '}
          {offer.supplier_price !== null ? (
            <span className="text-muted">
              {formatCurrency(offer.supplier_price)}
            </span>
          ) : (
            <span className="text-danger">--</span>
          )}
        </ListGroup.Item>
        {offer.vendor !== null && (
          <ListGroup.Item variant={offer.available ? 'unknown' : 'warning'}>
            <span>
              <strong>Продавец:</strong>
            </span>{' '}
            <span className="text-muted">{offer.vendor.name}</span>
          </ListGroup.Item>
        )}
      </ListGroup>
    </Card>
  );
};
